
import Vant, { Toast, Dialog } from 'vant'
// 先引入自定义主题
import 'vant/lib/index.less'

const vantUI = async Vue => {
  Vue.prototype.$dialog = Dialog
  Vue.prototype.$toast = Toast

  Vue.use(Vant)
}
export default vantUI
